import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import type { UpdateNotificationTypesRequest } from 'src/types/email_notifications';
import axiosInstance from 'src/utils/axios';

const useUpdateNotificationTypesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateNotificationTypesRequest) => {
      await axiosInstance.put(api.updateNotificationTypes, body);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.client.notificationTypes(String(variables.contactMethodId)),
      });
    },
  });
};

export default useUpdateNotificationTypesMutation;
